import server from '../../utils/Server';
import moment from 'moment';

export function broadcastSubmittedSearchForm(flight_type) {
  return function(dispatch, getState) {
    var state = getState().productSearch;

    server.broadcastEvent({
      name: 'submitted_search_form',
      scope: 'search',
      properties: {
        searched_origin: state.origin_selections.map(x => x.code),
        searched_destination: state.destination_selections.map(x => x.code)        
      }
    });
  }
}

export function broadcastSelectedDepartureDate() {
  return function(dispatch, getState) {
    var state = getState().productSearch;

    server.broadcastEvent({
      name: 'selected_departure_date',
      scope: 'search',
      properties: {
        departure_date: moment(state.travel_date_selection).format('YYYY-MM-DD'),
        searched_origin: state.origin_selections.map(x => x.code),
        searched_destination: state.destination_selections.map(x => x.code)        
      }
    });
  }  
}

export function broadcastSelectedFlightType(flight_type) {
  return function(dispatch, getState) {
    var state = getState().productSearch;

    server.broadcastEvent({
      name: 'selected_flight_type',
      scope: 'search',
      properties: {
        flight_type: flight_type,
        searched_origin: state.origin_selections.map(x => x.code),
        searched_destination: state.destination_selections.map(x => x.code)        
      }
    });
  }
}

export function broadcastSelectedCharterTime() {
  return function(dispatch, getState) {
    var state = getState().productSearch;

    server.broadcastEvent({
      name: 'selected_charter_time',
      scope: 'search',
      properties: {
        departure_time: state.travel_time_selection
      }
    });
  }
}
